function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useRef, useEffect } from "react";
import { Box } from "sprout-ui-primitives";
import { PopoverDialog, PopoverDialogContextualActionBar, PopoverDialogContextualActionBarCloseButton, PopoverDialogContextualActionBarSaveButton, PopoverDialogSaveButton } from "sprout-ui-dom/dist/PopoverDialog";
import { Form } from "sprout-ui-dom/dist/Form";
import useUpdateItem from "@sprout/client-graphql/dist/mutations/useUpdateItem";
import { TextField } from "sprout-ui-dom/dist/TextField_next";
import { useNavigationActiveLock } from "@sprout/list-navigation";
import PopoverDialogContent from "../PopoverDialogContent";
const EditSectionPopoverDialog = (props)=>{
    const { topic , showDescription , isRootTopic  } = props;
    const { id , title , description  } = topic;
    const { placement , open , onOpenChange , triggerElement , referenceElement , onOutsideClick ,  } = props;
    const handleClose = useCallback(()=>{
        onOpenChange(false);
    }, [
        onOpenChange
    ]);
    const topicNameRef = useRef(null);
    useEffect(()=>{
        if (open) {
            var ref;
            const { matches  } = window.matchMedia("only screen and (hover:hover) and (pointer:fine)");
            if (matches) (ref = topicNameRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        open
    ]);
    const handleFocus = useCallback((event)=>{
        event.target.select();
    }, []);
    const [inputValues, setInputValues] = useState({
        topicName: title || "",
        topicDescription: description || ""
    });
    const inputValuesRef = useRef(inputValues);
    const handleChange = useCallback((event)=>{
        const { value , name  } = event.target;
        setInputValues((v)=>{
            return _objectSpread({}, v, {
                [name]: value
            });
        });
        inputValuesRef.current[name] = value;
    }, []);
    const updateItem = useUpdateItem();
    const handleSubmit = useCallback(()=>{
        const { topicName , topicDescription  } = inputValuesRef.current;
        updateItem({
            itemId: id,
            title: topicName || null,
            description: topicDescription || null
        });
        handleClose();
    }, [
        handleClose,
        id,
        updateItem
    ]);
    const handleKeydown = useCallback((event)=>{
        if (event.key === "Escape") handleClose();
    }, [
        handleClose
    ]);
    const disabled = inputValues.topicName.length === 0;
    useNavigationActiveLock(open);
    return /*#__PURE__*/ _jsxs(PopoverDialog, {
        placement: placement,
        onOpenChange: onOpenChange,
        triggerElement: triggerElement,
        referenceElement: referenceElement,
        onOutsideClick: onOutsideClick,
        open: open,
        children: [
            /*#__PURE__*/ _jsx(PopoverDialogContextualActionBar, {
                contextualTitle: `Edit ${isRootTopic ? "tree" : "branch"}`,
                leftAction: /*#__PURE__*/ _jsx(PopoverDialogContextualActionBarCloseButton, {
                    onClick: handleClose
                }),
                rightAction: /*#__PURE__*/ _jsx(PopoverDialogContextualActionBarSaveButton, {
                    onClick: handleSubmit
                })
            }),
            /*#__PURE__*/ _jsxs(PopoverDialogContent, {
                as: Form,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        mb: 3,
                        children: /*#__PURE__*/ _jsx(TextField, {
                            ref: topicNameRef,
                            onFocus: handleFocus,
                            maxLength: 50,
                            id: "topicName",
                            name: "topicName",
                            labelText: "Name",
                            value: inputValues.topicName,
                            placeholder: `Like "Recipes"`,
                            onChange: handleChange,
                            onKeyDown: handleKeydown
                        })
                    }),
                    showDescription && /*#__PURE__*/ _jsx(Box, {
                        mb: 3,
                        children: /*#__PURE__*/ _jsx(TextField, {
                            value: inputValues.topicDescription,
                            maxLength: 160,
                            id: "topicDescription",
                            name: "topicDescription",
                            labelText: "Description",
                            placeholder: "What's your tree about?",
                            onChange: handleChange,
                            multiline: true,
                            onKeyDown: handleKeydown
                        })
                    }),
                    /*#__PURE__*/ _jsx(PopoverDialogSaveButton, {
                        type: "submit",
                        disabled: disabled,
                        children: "Save"
                    })
                ]
            })
        ]
    });
};
export default EditSectionPopoverDialog;
